import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable()
export class OrdersService {
  private baseUrl = environment.API;

  constructor(private http: HttpClient) {}

  public get() {
    const url = `${this.baseUrl}/printorders/`;
    return this.http.get(url);
  }
}
